(function ($) {
  if ($('.views-exposed-form select').length > 0) {

    // Los submits programáticos (sincronización inicial de filtros) disparan
    // el comando viewsScrollTop de Views, que desplaza la página hasta el
    // bloque de la vista al cargar. Este flag lo silencia mientras esos
    // submits están en curso, sin afectar al scroll legítimo de la paginación.
    var suppressViewsScrollTop = false;

    $(document).on('ajaxStop', function () {
      suppressViewsScrollTop = false;
    });

    window.addEventListener('load', function () {
      // El comando que envía ViewAjaxController es "scrollTop" (el antiguo
      // "viewsScrollTop" es solo un alias deprecado que delega en este).
      var originalScrollTop = Drupal.AjaxCommands.prototype.scrollTop;
      if (originalScrollTop) {
        Drupal.AjaxCommands.prototype.scrollTop = function (ajax, response) {
          if (suppressViewsScrollTop) {
            return;
          }
          return originalScrollTop.call(this, ajax, response);
        };
      }
    });

    $.fn.customSelect = function() {

      $('.views-exposed-form select').each(function () {
        if ($(this).parents().eq(1).attr('id') != 'views-exposed-form-view-events-events-past-block'){

          var $this = $(this),
              numberOfOptions = $(this).children('option').length;
             $this.addClass('select-hidden');

            $this.wrap('<div class="select"></div>');
            $this.after('<ul class="select-options"></ul>');
            $this.after('<div class="select-styled"></div>');

            for (var i = 0; i < numberOfOptions; i++) {
              $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
              }).appendTo($this.siblings('ul.select-options'));
            }

          var $styledSelect = $this.next('div.select-styled');
          $styledSelect.text($this.children(':selected').text());
          var $list = $this.siblings('ul.select-options');
          var $listItems = $list.children('li');

          $styledSelect.click(function (e) {
            e.stopPropagation();
            // Dropdown in calls custom form
            $('.form-composite.active').removeClass('active');

            // Toggle select-styled
            $('div.select-styled.active').not(this).each(function () {
              $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();
          });
          $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
          });
          $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
          });
        }
      });

      // Check if the element is exists view past events
      if( $('#views-exposed-form-view-events-events-past-block').length ){
        $('#views-exposed-form-view-events-events-past-block select').val($('#views-exposed-form-view-events-events-page-block select').children('option:selected').val());
        suppressViewsScrollTop = true;
        $('#views-exposed-form-view-events-events-past-block .js-form-submit').trigger('click');
      }

      $('.views-exposed-form .select .select-options li').click(function () {
          // Check if the element is the filter of news by research programme
          if( $(this).parents().eq(2).hasClass('js-form-item-field-news-research-programme-target-id') ){
            $('.js-form-item-field-news-research-group-target-id input').val("");
          }
          // Refresh custom  filter when ajax is complete
          $( document ).ajaxComplete(function () {
            if ( $('.select').length == 0) {
              $(this).customSelect();
            }
            $(this).customExposedInput();
          });
          $(this).parents().eq(3).find('.js-form-submit').trigger('click');
        });
        $('.pagination .page-item a').click(function () {
          $( document ).ajaxComplete(function () {
            if ( $('.select').length == 0) {
              $(this).customSelect();
            }
            $(this).customExposedInput();
          });
        });
    };

    //Transform input exposed filter researchGroups in select list
    $.fn.customExposedInput = function() {

      var idForm = $('.views-exposed-form').attr('id');

      if (idForm == 'views-exposed-form-view-news-news-page-block' || idForm == 'views-exposed-form-view-news-media-mentions-page-block'){
        var researchGroups = drupalSettings.irbradix.researchGroups;
        $('.views-exposed-form .js-form-type-textfield input').each(function () {

          var $this = $(this);

          var programmeSelect = $('.form-item-field-news-research-programme-target-id select');
          var programmeSelectVal = programmeSelect.val();

          $this.addClass('select-hidden');

          $this.wrap('<div class="input"></div>');
          $this.after('<ul class="select-options"><li rel="">' + $(this).attr("placeholder") +'</li></ul>');
          $this.after('<div class="select-styled">' + $(this).attr("placeholder") + '</div>');

          if (programmeSelectVal != 'All'){
            var researchGroupsCat = researchGroups.groups.filter(function (el){
              return el.cat == programmeSelectVal;
            });
            for (var arrayKey in researchGroupsCat) {
              $('<li />', {
                text: researchGroupsCat[arrayKey].name,
                rel: researchGroupsCat[arrayKey].id
              }).appendTo($this.siblings('ul.select-options'));
            }
          }else{
            for (var arrayKey in researchGroups.groups) {
              $('<li />', {
                text: researchGroups.groups[arrayKey].name,
                rel: researchGroups.groups[arrayKey].id
              }).appendTo($this.siblings('ul.select-options'));
            }
          }

          var $styledSelect = $this.next('div.select-styled');
          if($this.val() != ""){
            var $textVal = researchGroups.groups.find(function (el){
              return el.id == $this.val();
            });
            $textVal = $textVal.name;
            $styledSelect.text($textVal);
          }
          var $list = $this.siblings('ul.select-options');
          var $listItems = $list.children('li');

          $styledSelect.click(function (e) {
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function () {
              $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();
          });
          $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
          });
          $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
          });
        });
      };

      $('.views-exposed-form .input .select-options li').click(function () {
        $( document ).ajaxComplete(function () {
          if ( $('.input').length == 0) {
            $(this).customExposedInput();
            $(this).customSelect();
           }
        });
        $(this).parents().eq(3).find('.js-form-submit').trigger('click');
      });
    }

    function resetFilter() {
      const selects = document.querySelectorAll('.select')
      selects.forEach(select => {
        const textContent = select.querySelector('.select-styled').textContent
        const options = select.querySelectorAll('.select-options > li')
        const newOption = Array.from(options).find(li => li.textContent === textContent)
        suppressViewsScrollTop = true
        newOption.click()
      })
    }

    window.addEventListener('load', () => {
      $(this).customSelect()
      $(this).customExposedInput()
      resetFilter()
    });
  }

})(jQuery, Drupal);
